import { render, staticRenderFns } from "./Vas.vue?vue&type=template&id=0b45a281&scoped=true&"
import script from "./Vas.vue?vue&type=script&lang=ts&"
export * from "./Vas.vue?vue&type=script&lang=ts&"
import style0 from "./Vas.vue?vue&type=style&index=0&id=0b45a281&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b45a281",
  null
  
)

export default component.exports